import {useEffect} from 'react'

import {useDispatch, useSelector} from 'react-redux'

import {
  selectIsWarehousesAndMovementsDataLoaded,
  selectMovementTypes,
  selectUsersWithMovements,
  selectWarehouses
} from '../../slices/info/infoSelectors'
import {loadWarehousesAndMovementData} from '../../slices/thunks'

export const useWarehouseAndMovementData = () => {
  const dispatch = useDispatch()

  const isLoaded = useSelector(selectIsWarehousesAndMovementsDataLoaded)
  const movementTypes = useSelector(selectMovementTypes)
  const warehouses = useSelector(selectWarehouses)
  const usersWithMovements = useSelector(selectUsersWithMovements)

  useEffect(() => {
    if (!isLoaded) {
      dispatch(loadWarehousesAndMovementData())
    }
  }, [isLoaded, dispatch])

  return {
    movementTypes,
    warehouses,
    usersWithMovements
  }
}
